import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { WarningIcon } from "../../../../images/icons/icons";
import {
  ALERT_KEYS,
  EXCLUDED_KEYS,
  getCardBg,
  getCardIcon,
  getCardLabel,
  getCardSubLabel,
  getCardText,
  getCardValue,
  getFilterType,
  HIGHLIGHTED_KEYS,
} from "../LMSStatMocks";
import CalendarLoader from "../../../common-components/CalendarLoader";
import CommonStatCard from "../../../pt/pt-flow-new/CommonStatCard";

const LMSStatCards = ({ onCardClick, activeKey }) => {
  const { leadStatsLoading, leadStats, leadStatsError } = useSelector(
    (state) => state.api
  );

  const [leadStatsData, setLeadStatsData] = useState({});
  const [showAll, setShowAll] = useState(false);

  const handleCardClick = (key) => {
    if (onCardClick) {
      const filterType = getFilterType(key);
      onCardClick(filterType, key);
    }
  };

  useEffect(() => {
    if (
      !leadStatsLoading &&
      !leadStatsError &&
      leadStats?.status &&
      leadStats?.data
    ) {
      setLeadStatsData(leadStats);
    } else {
      setLeadStatsData({});
    }
  }, [leadStatsLoading, leadStatsError, leadStats]);

  return (
    <>
      {leadStatsLoading ? (
        <div className="lead-v2-stat-card-row mt15 mb30">
          <CalendarLoader daysCount={4} shiftsPerDay={2} />
        </div>
      ) : (
        <>
          <div className="lead-v2-stat-card-row mt30">
            {leadStatsData?.data &&
              Object.entries(leadStatsData?.data)
                .sort(([keyA], [keyB]) => {
                  const indexA = HIGHLIGHTED_KEYS.indexOf(keyA);
                  const indexB = HIGHLIGHTED_KEYS.indexOf(keyB);

                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;
                  return indexA - indexB;
                })
                .map(([key, value], index) => (
                  <React.Fragment key={index}>
                    {HIGHLIGHTED_KEYS.includes(key) && (
                      <div
                        className={`lead-v2-stat-card ${getCardBg(key)} ${
                          activeKey === getFilterType(key) ? "active" : ""
                        }`}
                        key={index}
                        onClick={() => handleCardClick(key)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="lead-v2-stat-card-content">
                          <div className="lead-v2-stat-card-label">
                            {getCardLabel(key)}
                          </div>
                          <div className="lead-v2-stat-card-value">
                            {getCardValue(key, value)}
                          </div>
                          <div className="lead-v2-stat-card-sub">
                            {getCardSubLabel(key, leadStatsData, value)}
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
            {/* 
            {leadStatsData?.data &&
              Object.entries(leadStatsData?.data)
                .sort(([keyA], [keyB]) => {
                  const indexA = EXCLUDED_KEYS.indexOf(keyA);
                  const indexB = EXCLUDED_KEYS.indexOf(keyB);

                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;
                  return indexA - indexB;
                })
                .map(([key, value], index) => (
                  <React.Fragment key={index}>
                    {!EXCLUDED_KEYS.includes(key) && (
                      <div
                        className={`lead-v2-stat-card ${getCardBg(key)} ${
                          activeKey === getFilterType(key) ? "active" : ""
                        } ${getCardBg(key)}`}
                        key={index}
                        onClick={() => handleCardClick(key)}
                      >
                        <div className="lead-v2-stat-card-content">
                          <div className="lead-v2-stat-card-label c-black">
                            {getCardLabel(key)}
                          </div>
                          <div className="lead-v2-stat-card-value c-black">
                            {getCardValue(key, value)}
                          </div>
                          <div className="lead-v2-stat-card-sub c-black">
                            {getCardSubLabel(key, leadStatsData, value)}
                          </div>
                        </div>
                        <div className="lead-v2-stat-card-icon c-black">
                          {getCardIcon(key)}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))} */}
          </div>

          <div className="cards-container cards-grid-container lms-stat-card-container grid-4">
            {leadStatsData?.data &&
              Object.entries(leadStatsData?.data)
                .sort(([keyA], [keyB]) => {
                  const indexA = EXCLUDED_KEYS.indexOf(keyA);
                  const indexB = EXCLUDED_KEYS.indexOf(keyB);

                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;
                  return indexA - indexB;
                })
                .map(([key, value], index) => (
                  <React.Fragment key={index}>
                    {!EXCLUDED_KEYS.includes(key) && (
                      <CommonStatCard
                        tagName="lms"
                        classname={
                          activeKey === getFilterType(key) ? "active" : ""
                        }
                        cardLabel={getCardLabel(key)}
                        value={getCardValue(key, value)}
                        icon={getCardIcon(key, leadStatsLoading)}
                        onClickCard={() => handleCardClick(key)}
                      />
                    )}
                  </React.Fragment>
                ))}
          </div>

          {/* <div className="lead-v2-show-more-row">
            <span
              className="lead-v2-show-more-btn"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "View less cards" : "Show all cards"}
            </span>
          </div> */}

          <div className="lead-v2-alert-section">
            <div className="lead-v2-alert-title">
              <WarningIcon />
              <span>Action Required - Priority Alerts</span>
            </div>

            <div className="lead-v2-alert-card-row">
              {leadStatsData?.data &&
                Object.entries(leadStatsData?.data)
                  .sort(([keyA], [keyB]) => {
                    const indexA = ALERT_KEYS.indexOf(keyA);
                    const indexB = ALERT_KEYS.indexOf(keyB);

                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;
                    return indexA - indexB;
                  })
                  .map(([key, value], index) => (
                    <React.Fragment key={index}>
                      {ALERT_KEYS.includes(key) && (
                        <div
                          className={`lead-v2-alert-card ${
                            activeKey === getFilterType(key) ? "active" : ""
                          }`}
                          key={index}
                          onClick={() => handleCardClick(key)}
                          style={{
                            borderColor: getCardText(key),
                            background: getCardBg(key),
                            color: getCardText(key),
                            cursor: "pointer",
                          }}
                        >
                          <div className="lead-v2-alert-card-label">
                            {getCardLabel(key)}
                          </div>
                          <div className="lead-v2-alert-card-value">
                            {getCardValue(key, value)}
                          </div>
                          <div
                            className="lead-v2-alert-card-sub"
                            style={{ color: getCardText(key) }}
                          >
                            {getCardSubLabel(key, leadStatsData, value)}
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LMSStatCards;
